import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { UnitType } from '../types/unit-type.interface';

export const unitTypeDefinition: EntityDefinition<UnitType> = {
  entityType: 'UnitType',
  i18nBase: 'entities.unitType',
  enableFiltering: true,
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'common.labels.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [{ field: 'name', labelKey: 'common.labels.name', required: true, type: 'text', minLength: 3, maxLength: 50 }],
  validationRules: [
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: UnitType, store) => {
        if (!store) return true;
        const entities = store.getData<UnitType>('UnitType')();
        return !entities.some(type => type.name.toLowerCase().trim() === entity.name.toLowerCase().trim() && type.id !== entity.id);
      },
      errorMessageKey: 'entities.unitType.messages.duplicateError',
    },
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: UnitType) => !entity.hasUnit,
      errorMessageKey: 'entities.unitType.messages.deleteError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.unitType.messages.createTitle',
      edit: () => 'entities.unitType.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.unitType.messages.addButton',
      create: () => 'entities.unitType.messages.addButton',
      edit: () => 'entities.unitType.messages.editTitleWithName',
      delete: () => 'entities.unitType.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.unitType.messages.deleteConfirm',
  },
};
